import axios from 'axios'

export const getMember = (store) => {
    return axios.get('member')
      .then((result) => {
        store.commit('setUser', result.data)
        return result
      })
      .catch((error) => {
        return error
      })
}

export const getMemberById = (memberId) => {
  return axios.get('member/' + memberId)
    .then((result) => {
      return result
    })
    .catch((error) => {
      return error
    })
}

export const purchase = (requestBody) => {
  return axios.post('payment/purchase', requestBody)
    .then((result) => {
      return result
    })
    .catch((error) => {
      return error
    })
}

export const subscribe = (store, requestBody) => {
  return axios.post('payment/process', requestBody)
    .then((result) => {
      if (result.status === 200) {
        store.commit('setUserSubscription', result.data)
      }
      return result
    })
    .catch((error) => {
      return error
    })
}

export const cancelSubscription = (store, requestBody) => {
  return axios.post('payment/cancel', requestBody)
    .then((result) => {
      if (result.status === 200) {
        store.commit('setUserSubscription', result.data)
      }
      return result
    })
    .catch((error) => {
      return error
    })
}

export const changePassword = (userId, code, newPassword) => {
  return axios.get('auth/resetpassword/validate', {params: { userId: userId, code: code, newPassword: newPassword }})
    .then((result) => {
      return result
    })
    .catch((error) => {
      return error
    })
}

export default {}